import { DEFAULT_POST_LOGIN_PATH, TRIAL_UPLOAD_ONBOARDING_PATH } from "./postLogin";

export async function resolvePostLoginDestination(
  authorization?: string,
  scope?: { organizationId?: string; teamId?: string },
): Promise<string> {
  try {
    const params = new URLSearchParams();
    if (scope?.organizationId) params.set("organizationId", scope.organizationId);
    if (scope?.teamId) params.set("teamId", scope.teamId);
    const query = params.toString();
    const response = await fetch(`/api/auth/post-login-destination${query ? `?${query}` : ""}`, {
      headers: authorization ? { Authorization: authorization } : undefined,
      cache: "no-store",
    });
    if (!response.ok) return DEFAULT_POST_LOGIN_PATH;

    const result = (await response.json()) as { path?: unknown };
    return result.path === TRIAL_UPLOAD_ONBOARDING_PATH ? result.path : DEFAULT_POST_LOGIN_PATH;
  } catch {
    return DEFAULT_POST_LOGIN_PATH;
  }
}
